import {Component} from './component'
import {provider} from './provider'

export const WidgetContainer = provider(Component)
